import { render, staticRenderFns } from "./secretInfo.vue?vue&type=template&id=6c0c687c&scoped=true"
import script from "./secretInfo.vue?vue&type=script&lang=js"
export * from "./secretInfo.vue?vue&type=script&lang=js"
import style0 from "./secretInfo.vue?vue&type=style&index=0&id=6c0c687c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c687c",
  null
  
)

export default component.exports